'use strict';

var novicell = novicell || {};

novicell.languagePicker = novicell.languagePicker || new function () {

  this.init = function () {
    let languageTrigger = document.querySelectorAll('.js-language-picker');
    if (languageTrigger.length) {
      for (let i = 0; i < languageTrigger.length; i++) {
        languageTrigger[i].addEventListener('click', function () {
          this.parentNode.querySelector('.js-language-picker-dropdown').classList.toggle('language-picker__dropdown--active');
        });
      }
      let languageMobileTarget = document.querySelector('.nav-main');
      let languageDesktopTarget = document.querySelector('.header__language-picker');
      let languagePicker = document.querySelector('.language-picker');
      moveLanguagePickerMobile(languageMobileTarget, languageDesktopTarget, languagePicker, false);
      window.addEventListener('resize', function () {
        moveLanguagePickerMobile(languageMobileTarget, languageDesktopTarget, languagePicker, true);
      });
    }
  };

  function moveLanguagePickerMobile(languageMobileTarget, languageDesktopTarget, languagePicker, inResize) {
    let label = languagePicker.querySelector('.language-picker__label');
    if (document.body.clientWidth < 992) {
      languagePicker.classList.add('language-picker--mobile');
      languageMobileTarget.appendChild(languagePicker);
      label.innerHTML = label.getAttribute('data-full-name');
    } else {
      languagePicker.classList.remove('language-picker--mobile');
      languageDesktopTarget.appendChild(languagePicker);
      if (inResize) {
        label.innerHTML = label.getAttribute('data-short-name');
      }
    }
  }

}();
